import env from '../helpers/env';

// @todo can we test for these?

export default () => ['Firefox', 'Safari', 'Edge', 'Chrome', 'Opera'].indexOf(env.name) > -1;
